import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, InputNumber, Input, Space, Tag, Typography, message } from "antd";
import { NotificationOutlined, CheckOutlined, StopOutlined } from "@ant-design/icons";
import {
  getMaintenanceStatus, announceMaintenance, startMaintenance,
  finishMaintenance, clearMaintenance,
} from "../../api/client";
import { faNum } from "../../utils/faNumberFormat";

const { Text } = Typography;

const PHASE = {
  scheduled: { l: "اعلام‌شده — در حالِ شمارشِ معکوس", c: "gold" },
  in_progress: { l: "در حالِ بروزرسانی", c: "blue" },
  done: { l: "تمام‌شده", c: "green" },
  idle: { l: "اعلانی فعال نیست", c: "default" },
};

/**
 * کنترلِ دستیِ اعلانِ بروزرسانی.
 *
 * همان کاری که اسکریپتِ دیپلوی از خطِ فرمان می‌کند، اینجا برای وقتی است که
 * کارِ سنگینی (مثلاً بازگردانیِ بکاپ) قرار است انجام شود و کاربران باید دست
 * نگه دارند.
 */
export default function MaintenanceAnnounceCard() {
  const [st, setSt] = useState(null);
  const [lead, setLead] = useState(20);
  const [dur, setDur] = useState(90);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    getMaintenanceStatus().then((r) => setSt(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [load]);

  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); message.success(ok); load(); }
    catch (e) { message.error(e?.response?.data?.detail || "خطا"); }
    setBusy(false);
  };

  const phase = st?.phase || "idle";
  const meta = PHASE[phase] || PHASE.idle;

  return (
    <Card size="small" title="اعلانِ بروزرسانی به کاربران" style={{ marginTop: 12 }}
      extra={<Tag color={meta.c}>{meta.l}</Tag>}>
      <Text type="secondary" style={{ fontSize: 12 }}>
        همهٔ کاربرانِ آنلاین پاپ‌آپ می‌بینند و فرصت دارند کارِ نیمه‌کاره را ذخیره کنند.
      </Text>
      <Space wrap style={{ marginTop: 10 }}>
        <span>مهلتِ ذخیره (ثانیه):</span>
        <InputNumber min={0} max={600} value={lead} onChange={setLead} style={{ width: 90 }} />
        <span>مدتِ تخمینی (ثانیه):</span>
        <InputNumber min={5} max={3600} value={dur} onChange={setDur} style={{ width: 90 }} />
      </Space>
      <Input style={{ marginTop: 10 }} value={note} onChange={(e) => setNote(e.target.value)}
        placeholder="توضیحِ اختیاری (مثلاً: افزودنِ گزارشِ جدید)" allowClear />
      <Space wrap style={{ marginTop: 12 }}>
        <Button type="primary" icon={<NotificationOutlined />} loading={busy}
          onClick={() => run(() => announceMaintenance({
            lead_seconds: lead, duration_seconds: dur, message: note || null,
          }), "اعلان برای همهٔ کاربران فرستاده شد")}>
          اعلامِ بروزرسانی
        </Button>
        <Button loading={busy} onClick={() => run(startMaintenance, "شروع اعلام شد")}>
          شروعِ فوری
        </Button>
        <Button icon={<CheckOutlined />} loading={busy}
          onClick={() => run(finishMaintenance, "پایان اعلام شد")}>
          پایانِ بروزرسانی
        </Button>
        <Button danger icon={<StopOutlined />} loading={busy}
          onClick={() => run(clearMaintenance, "اعلان پاک شد")}>
          لغوِ اعلان
        </Button>
      </Space>
      {phase === "scheduled" && (
        <div style={{ marginTop: 10 }}>
          <Text>شروع تا <b>{faNum(st.seconds_until_start)}</b> ثانیهٔ دیگر</Text>
        </div>
      )}
      {phase === "in_progress" && st?.seconds_remaining != null && (
        <div style={{ marginTop: 10 }}>
          <Text>حدوداً <b>{faNum(st.seconds_remaining)}</b> ثانیه تا پایان</Text>
        </div>
      )}
    </Card>
  );
}
